"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsx2 = _interopRequireDefault(require("@babel/runtime/helpers/jsx"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Row = _interopRequireDefault(require("@emcasa/ui-dom/components/Row"));

var _styles = require("../shared/styles");

var _ExclamationIcon = require("../../../shared/ExclamationIcon");

var _ = _interopRequireDefault(require("../.."));

var _ref2 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.IconWrapper, {}, void 0, (0, _jsx2["default"])(_ExclamationIcon.ExclamationIcon, {}));

var _ref3 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.TitleText, {
  color: "pink"
}, void 0, "Ocorreu um erro ao receber os seus dados");

var _ref4 =
/*#__PURE__*/
(0, _jsx2["default"])(_styles.InfoText, {}, void 0, "Tente enviar o seu c\xF3digo de acesso novamente");

var TokenError = function TokenError(_ref) {
  var goToStep = _ref.goToStep;
  return (0, _jsx2["default"])(_Row["default"], {
    flexDirection: "column"
  }, void 0, _ref2, _ref3, _ref4, (0, _jsx2["default"])(_styles.CTAButton, {
    fluid: true,
    active: true,
    mt: 4,
    onClick: function onClick() {
      return goToStep(_["default"].STEP_NAMES.token);
    }
  }, void 0, "Tentar novamente"));
};

TokenError.propTypes = {
  goToStep: _propTypes["default"].func.isRequired
};
var _default = TokenError;
exports["default"] = _default;